"use client";

import React from "react";
import {cn} from "@/lib/utils";
import Image from "next/image";
import {GROQImage} from "@/sanity/lib/types";

export default function CornerChip({
  image,
  text,
  className = "",
  style,
}: {
  image?: GROQImage;
  text: string;
  className?: string;
  style?: React.CSSProperties;
}) {
  if (!text) return null;

  return (
    <div
      className={cn(
        "inline-flex items-center gap-[1rem] min-h-[5rem] pl-[1.5rem] pr-[2rem] prose-p:text-black bg-[#D9F9B9]",
        "[clip-path:polygon(0_0,calc(100%-1.875rem)_0,100%_1.875rem,100%_100%,0_100%)]",
        className
      )}
      style={style}
    >
      {image && (
        <Image
          className="!w-[3rem]"
          src={image}
          alt=""
        />
      )}
      <p className="font-geistmono mb-0 leading-none text-[2rem]">{text}</p>
    </div>
  );
}
